import { Item } from '@/components/parts/catalog/list';
import { pluralizeWeeks, pluralizeHours } from '@/tools/pluralize';

export interface Image {
  big?: string;
  little?: string;
  original?: string;
  url?: string;
}

export interface Params {
  id: any;
  url_code: any;
  name: any;
  announce: any;
  age_group_text: any;
  min_price: any;
  count_group_text: any;
  max_person: any;
  length_text: any;
  is_locked?: any;
  available_order_next_year?: any;
  available_order_current_year?: any;
  sub_section_significant?: any;
  is_pfdod?: any;
  is_ovz?: any;
  image: Image;
  cost?: string | number;
  form_education_id?: string | number;
  is_open?: boolean;
  is_free?: boolean;
  labor_program?: string | number;
  length?: string | number;
  cop_multi_name: string;
}

export const convertEventsFromApi = ({
  id,
  url_code,
  name,
  announce,
  age_group_text,
  min_price,
  count_group_text,
  max_person,
  length_text,
  is_locked = false,
  available_order_next_year = true,
  available_order_current_year = false,
  sub_section_significant = false,
  is_pfdod = false,
  is_ovz = false,
  image = {},
  cost = '',
  form_education_id,
  is_open = true,
  is_free = false,
  labor_program = '',
  length = '',
  cop_multi_name = ''
}: Params): Item => {
  const { little = '', big = '' } = image;
  return {
    id: id,
    code: url_code,
    title: name,
    note: announce,
    image: {
      small: little,
      large: big,
    },
    age: age_group_text,
    price: min_price ? Number(min_price) : 0,
    size: count_group_text,
    max_person,
    duration: length_text,
    cop_multi_name: cop_multi_name,
    rate: true,
    rating: 0,
    is_locked,
    available_order_next_year,
    available_order_current_year,
    sub_section_significant,
    is_pfdod: !!is_pfdod,
    ovz: !!is_ovz,
    cost,
    is_free,
    form_education_id,
    is_open: !!is_open,
    labor_program: pluralizeHours(labor_program),
    length: pluralizeWeeks(length),
  };
};

export default convertEventsFromApi;



// WEBPACK FOOTER //
// ./src/helpers/convertEventsFromApi.ts